import { Component, Input, Output, EventEmitter, NgZone } from '@angular/core';
import { NavController } from 'ionic-angular';

/**
   * Logger Factory

*/

@Component({
  selector: 'ute-confirm-drawer',
  templateUrl: 'ute-confirm-drawer.component.html'
})

export class UteConfirmDrawer {
  @Input() isDrawerOpen: boolean;
  @Input() cancel: boolean = false;
  @Input() cancelLabel: string;
  @Input() action: string;
  @Input() actionLabel: string;
  @Input() icon: string;
  @Input() title: string;
  @Input() description: string;

  @Output() isDrawerOpenChange = new EventEmitter;
  @Output() onClickAction = new EventEmitter;
  @Output() onChangePrivacy = new EventEmitter;

  constructor(
    public navCtrl: NavController,
    public zone: NgZone
  ) { }

  ionViewDidLoad() { }

  // onChangeDrawer(event){
  //   this.isDrawerOpenChange.emit(false);
  // }

  // onSubmitAction(event){
  //   this.onClickAction.emit(event);
  // }

  goToLogin() {
    this.navCtrl.push('login');
  }

  goToHome() {
    this.zone.run(() => {
      this.navCtrl.push('dashboard');
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/user/components/ute-confirm-drawer/ute-confirm-drawer.component.ts